import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserProvider } from "./context/UserContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { getDeviceId } from "./utils/deviceId";


getDeviceId();

// ✅ Adjust body padding ONLY when Marathi (Google Translate) is active
(function handleTranslatePadding() {
  const APPLY_PADDING = () => {
    const htmlLang = document.documentElement.lang;

    // Google sets lang="mr" when Marathi is active
    if (htmlLang === "mr") {
      document.body.style.paddingTop = "48px"; // height of Chrome translate bar
    } else {
      document.body.style.paddingTop = "0px";
    }
  };

  // Run once
  APPLY_PADDING();

  // Watch for language changes
  const observer = new MutationObserver(APPLY_PADDING);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["lang"],
  });
})();


// // 🔥 FORCE REMOVE GOOGLE TRANSLATE TOP BAR
// (function hideGoogleTranslateBar() {
//   const removeBar = () => {
//     const iframe = document.querySelector('iframe.goog-te-banner-frame');
//     if (iframe) {
//       iframe.remove();
//     }

//     document.body.style.top = '0px';
//     document.body.style.position = 'static';
//     document.documentElement.style.marginTop = '0px';
//   };

//   // run immediately
//   removeBar();

//   // keep watching (Google reinjects it)
//   const observer = new MutationObserver(removeBar);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//   });
// })();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>
);

// 🔥 Fix Google Translate banner layout shift
const googleTranslateFix = () => {
  const observer = new MutationObserver(() => {
    const banner = document.querySelector(".goog-te-banner-frame");
    if (banner) {
      banner.style.display = "none";
      document.body.style.top = "0px";
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

googleTranslateFix();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ⚠️ NOT register(). This CRA 5 setup has no workbox plugin and public/ contains
// no service-worker.js, so register() requests a file that does not exist. The
// server answers with the SPA fallback (index.html), and the browser rejects it:
//     Failed to register a ServiceWorker ... unsupported MIME type ('text/html')
// unregister() is also what removes a stale worker left by an earlier build.
// Switch back to register() only after adding a real service worker.
serviceWorkerRegistration.unregister();

